import { StatusColor } from '../../../types';
import { RadioColor } from './Radio.types';

/** Maps status colors to radio color classes. */
export const STATUS_COLOR_TO_RADIO_COLOR: Record<RadioColor, string> = {
  [StatusColor.ERROR]: 'radio-error',
  [StatusColor.SUCCESS]: 'radio-primary',
};
